<template>
  <div>
    <div id="particle-bg">
      <particles-bg color="#f7941e" num="20" type="cobweb" :bg="true" />
    </div>
    <div class="outer">
      <div class="container">
        <div class="center">
          <img src="../assets/error.png" alt="" />
          <h4>
            {{ this.contents.find(content => content.id_content === 173)?.title  }}
          </h4>
          <router-link to="/"
            ><button class="btn btn-primary">
            {{ this.contents.find(content => content.id_content === 174)?.title  }}
            </button></router-link
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {ParticlesBg} from "particles-bg-vue";
import {mapGetters} from "vuex";

export default {
  components: {
    ParticlesBg,
  },
  data: function () {
    return {
      contents: [],
    };
  },
  mounted() {
    this.getAllContent();
  },
  methods: {
    async getAllContent() {
      this.contents = [];
      try {
        await this.$store.dispatch("fetchContent");
        let lang = localStorage.getItem("lang") ? localStorage.getItem("lang") : "pt";
        for (let i = 0; i < this.getContent.data.length; i++) {
          if (this.getContent.data[i].page === 8) {
            let content = {
              id_content: this.getContent.data[i].id_content,
              title: lang === "pt" ? this.getContent.data[i].title : this.getContent.data[i].title_en,
              description: lang === "pt" ? this.getContent.data[i].description : this.getContent.data[i].description_en,
              img: this.img,
            };
            this.contents.push(content);
          }
        }
      } catch (err) {
        this.$router.push({name: "Error"});
      }
    }
  },
  computed: {
    ...mapGetters(["getContent"]),
  },
};
</script>
<style scoped>
#particles-bg {
  position: fixed;
  /* fill the entire page */
  width: 100%;
  height: 100%;
  /* remove the space along the edges */
  margin: 0;
  padding: 0;
  /* position it to start at the top of the page */
  top: 0;
  /* put it behind other content */
  z-index: -1;
}
h4 {
  padding-top: 10px;
  font-size: 30px;
  font-family: "Roboto", sans-serif;
  font-weight: 300;
  text-align: center;
}
.outer {
  display: table;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
}
.container {
  display: table-cell;
  vertical-align: middle;
}
.center {
  margin-left: auto;
  margin-right: auto;
  max-width: 900px;
  text-align: center;
}
button {
  margin-top: 20px;
  background-color: rgb(247, 149, 29);
  border: none;
  color: white;
  font-size: 18px;
}
button:focus {
  box-shadow: none;
}
button:hover {
  box-shadow: #888888;
  background-color: #888888;
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.08), 0 0 6px rgba(0, 0, 0, 0.05);
  transition: 0.3s transform cubic-bezier(0.155, 1.105, 0.295, 1.12),
    0.3s box-shadow,
    0.3s -webkit-transform cubic-bezier(0.155, 1.105, 0.295, 1.12);
}
img {
  padding: 50px 0px 0px 0px;
  max-width: 350px;
  margin: auto;
  display: block;
}
@media (max-width: 1000px) {
  img {
    padding: 50px 0px 30px 0px;
    max-width: 250px;
  }
  h4 {
    font-size: 25px;
  }
}
</style>
